import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
  forwardRef
} from "@angular/core";
import { TlaFormat } from "app/core/models/tla-format";
import { TlaOption } from "app/core/models/tla-option";
import { TlaSelectedOption } from "app/core/models/tla-selected-option";
import { TlaExtentOption } from "app/core/models/tla-extent-option";
import { TlaOptionValue } from "app/core/models/tla-option-value";
import { Dialog } from "app/core/models/dialog";
import { Loading } from "app/core/models/loading";
import { TlaSelectedExtentOption } from "app/core/models/tla-selected-extent-option";
import { CurriculumReview } from "app/core/models/curriculum-review";
import { CustomError } from "app/core/models/custom-error";

//Services
import { TlaService } from "app/core/services/tla.service";
import { DimmerService } from "app/core/services/dimmer.service";
import { AlertService } from "app/core/services/alert.service";

//Libraries
import { finalize } from "rxjs/operators";

@Component({
  selector: "app-user-step-tla",
  templateUrl: "./user-step-tla.component.html",
  styleUrls: ["./user-step-tla.component.scss"]
})
export class UserStepTlaComponent implements OnInit {
  @Input()
  review: CurriculumReview;
  @Input()
  courseId: number;

  // @Output()
  // nextStep: EventEmitter<any> = new EventEmitter();
  // @Output()
  // prevStep: EventEmitter<any> = new EventEmitter();

  loading: Loading;

  tlaFormat: TlaFormat;
  tlaOptions: Array<TlaOption> = [];
  tlaOptionsArray: Array<TlaOption> = [];
  selectedTlaOptions: Array<TlaSelectedOption> = [];
  selectedTlaIds: Array<number> = [];
  tlaToDelete: TlaSelectedOption;

  tlaExtentOption: TlaExtentOption;
  tlaExtentOptions: Array<TlaExtentOption> = [];
  tlaExtentOptionsForForm: Array<TlaExtentOption> = [];
  tlaExtentOptionsArray: Array<TlaExtentOption> = [];
  tlaExtentOptionDescriptionForForm: string;

  dialog: Dialog;

  //for form
  tlaOptionForForm: TlaSelectedOption;

  loadError: CustomError;
  actionErrors: Array<CustomError> = [];

  loadErrorTitle: string = "Error";
  actionErrorTitle: string = "Error";

  formProcessing: boolean = false;
  shouldShowForm: boolean = false;
  isTlaSelected: boolean = true;
  isTlaOptionOtherTextFilled: boolean = true;
  isTlaExtentOptionSelected: boolean = true;
  isTlaExtentOptionOtheTextFilled: boolean = true;
  dialogUpdating: boolean = false;

  constructor(
    // @Inject(forwardRef(() => UserCourseComponent))
    // private _parent: UserCourseComponent,
    private tlaService: TlaService,
    private dimmerService: DimmerService,
    private alertService: AlertService
  ) { }

  /*************************
   * Init
   * Error: Load errors
   *************************/
  async ngOnInit() {
    this.loading = new Loading(
      true,
      "Loading teaching and learning activities.."
    );

    //load tla format
    try {
      this.tlaFormat = await this.tlaService.getTlaFormatByCourseId(
        this.courseId
      );

      // console.log(this.tlaFormat);

      if (this.tlaFormat.isEnabled) {
        if (this.tlaFormat.format == "list") {
          this.tlaOptions = await this.tlaService.getAvailableTlaOptionsForCourse(
            this.courseId,
            this.tlaFormat.id
          );

          //convert to key value array
          this.tlaOptions.forEach(tlaOption => {
            this.tlaOptionsArray[tlaOption.id] = tlaOption;
          });

          this.selectedTlaOptions = await this.tlaService.getSelectedTlaOptionsForCourse(
            this.courseId,
            this.tlaFormat.id
          );
        } else if (this.tlaFormat.format == "text") {


          this.selectedTlaOptions = await this.tlaService.getSelectedTlaOptionsText(
            this.courseId,
            this.tlaFormat.id
          );


          // console.log(this.selectedTlaOptions);


        }

        if (
          this.tlaFormat.isExtentRequired 
        ) {
          this.tlaExtentOptions = await this.tlaService.getAvailableTlaExtentOptionsByCourseId(
            this.courseId,
            this.tlaFormat.id
          );

          //convert to key value array
          this.tlaExtentOptions.forEach(extentOption => {
            this.tlaExtentOptionsArray[extentOption.id] = extentOption;
          });

          for (let tlaSelectedOption of this.selectedTlaOptions) {
            let extentOption: TlaExtentOption = null;

            if (this.tlaFormat.extentFormat == "list") {
              if (this.tlaFormat.format == "text") {
                extentOption = await this.tlaService.getSelectedTlaExtentOptionForTextTla(
                  this.courseId,
                  this.tlaFormat.id,
                  tlaSelectedOption.selectionId
                );
              } else if (this.tlaFormat.format == "list") {
                extentOption = await this.tlaService.getSelectedTlaExtentOptionForListTla(
                  this.courseId,
                  this.tlaFormat.id,
                  tlaSelectedOption.selectionId
                );
              }
            }
            else if(this.tlaFormat.extentFormat == "text"){

              if (this.tlaFormat.format == "text") {

                //this data is included in selected tla option


              } else if (this.tlaFormat.format == "list") {


                extentOption = await this.tlaService.getSelectedTlaExtentOptionForTextTla(
                  this.courseId,
                  this.tlaFormat.id,
                  tlaSelectedOption.selectionId
                );

                  // console.log(extentOption);

              }


            }



            tlaSelectedOption.extentOption = extentOption;
          }
        }



      }
    } catch (error) {
      console.log(error);
      this.loadError = error;
    } finally {
      this.loading.isLoading = false;
    }
  }

  ///////////// Create TLA ////////////////

  /************************************
   * Open add tla form with empty value
   * V.1
   ************************************/
  openAddTlaForm() {
    // this.tlaSelectedOptionForForm = new TlaOption();

    this.isTlaSelected = true;
    this.isTlaExtentOptionSelected = true;

    //create an empty object
    this.tlaOptionForForm = new TlaSelectedOption(
      null,
      null,
      false,
      null,
      null,
      null,
      null
    );

    if (
      this.tlaFormat.isExtentRequired &&
      this.tlaFormat.extentFormat == "list"
    ) {
      this.tlaExtentOptionsForForm = [];

      if (this.tlaFormat.isExtentRequired) {
        this.tlaExtentOptions.forEach(extentOption => {
          this.tlaExtentOptionsForForm.push(
            new TlaExtentOption(
              extentOption.id,
              extentOption.description,
              extentOption.isTextRequired,
              extentOption.otherText,
              null,
              false
            )
          );
        });
      }
    }
    //console.log(this.tlaOptionForForm);

    this.dimmerService.dimWindow(true);
    this.shouldShowForm = true;
  }

  /************************************
   * Open edit TLA form
   * V.1
   ************************************/
  openEditTlaForm(tla: TlaSelectedOption) {
    // this.tlaSelectedOptionForForm = new TlaOption();

    this.isTlaSelected = true;
    this.isTlaExtentOptionSelected = true;

    //create an empty object
    this.tlaOptionForForm = new TlaSelectedOption(
      tla.id,
      tla.description,
      tla.isTextRequired,
      tla.flag,
      tla.selectionId,
      tla.additionalText,
      tla.extentText
    );

    if (
      this.tlaFormat.isExtentRequired &&
      this.tlaFormat.extentFormat == "list"
    ) {
      this.tlaExtentOptionsForForm = [];

      //console.log(this.tlaExtentOptions);

      if (tla.extentOption) {
        this.tlaExtentOptions.forEach(extentOption => {
          this.tlaExtentOptionsForForm.push(
            new TlaExtentOption(
              extentOption.id,
              extentOption.description,
              extentOption.isTextRequired,
              tla.extentOption.id == extentOption.id
                ? tla.extentOption.otherText
                : null,
              null,
              tla.extentOption.id == extentOption.id ? true : false
            )
          );
        });
      }

      this.tlaExtentOptionDescriptionForForm = tla.extentOption.otherText;
    }

    //console.log(this.tlaOptionForForm);

    this.dimmerService.dimWindow(true);
    this.shouldShowForm = true;
  }

  // //returns true if this tla is already selected (so cannot be selected again)
  // isThisTlaAlreadySelected(tla: TlaOption) {
  //   //if the option is 'other' return false, because it can be selected multiple times
  //   if (tla.isTextRequired) {
  //     return false;
  //   }
  //   return this.selectedTlaIds.indexOf(tla.id) > -1 ? true : false;
  // }

  /**********************************************
   * TLA Option is selected by user in the form
   * V.1
   **********************************************/
  tlaOptionSelected(tlaOptionId: number) {
    //console.log(tlaOptionId);

    //find this id in the options list
    for (let tlaOption of this.tlaOptions) {
      if (tlaOption.id == tlaOptionId) {
        this.tlaOptionForForm.id = tlaOption.id;
        this.tlaOptionForForm.description = tlaOption.description;
        this.tlaOptionForForm.isTextRequired = tlaOption.isTextRequired;
        this.tlaOptionForForm.flag = null;
        break;
      }
    }

    // this.tlaForForm.id = tlaId;
  }

  /**********************************************
   * TLA Extent Option is selected by user in the form
   * V.1
   **********************************************/
  extentOptionSelected(tlaExtentOptionId: number) {
    for (let tlaExtentOption of this.tlaExtentOptionsForForm) {
      if (tlaExtentOption.id == tlaExtentOptionId) {
        tlaExtentOption.isSelected = true;
      } else {
        tlaExtentOption.isSelected = false;
      }
    }
  }

  isExtentOptionSelected() {
    for (let extentOption of this.tlaExtentOptionsForForm) {
      if (extentOption.isSelected) {
        return true;
      }
    }

    // console.log("returning false");

    return false;
  }

  /****************************************************
   * Submit Tla option value (both create and update)
   * V.1
   * Error: Action Errors
   ************************************************/
  async submit() {
    this.formProcessing = true;
    this.actionErrors = [];

    //check if tla option is selected
    let verified: boolean = true;

    if (this.tlaFormat.format == "list") {
      if (!this.tlaOptionForForm.id) {
        this.isTlaSelected = false;
        verified = false;
      } else {
        this.isTlaSelected = true;
      }
    } else if (this.tlaFormat.format == "text") {
      //tla format is text
      if (!this.tlaOptionForForm.description) {
        this.isTlaSelected = false;
        verified = false;
      } else {
        this.isTlaSelected = true;
      }
    } else {
      this.isTlaSelected = true;
    }

    if (this.tlaFormat.isExtentRequired) {
      if (this.tlaFormat.extentFormat != "text") {
        if (!this.isExtentOptionSelected()) {
          this.isTlaExtentOptionSelected = false;
          verified = false;
        } else {
          this.isTlaExtentOptionSelected = true;
        }
      } else {
        //extent option is text
        if (!this.tlaOptionForForm.extentText) {
          this.isTlaExtentOptionSelected = false;
          verified = false;
        } else {
          this.isTlaExtentOptionSelected = true;
        }
      }
    }

    if (verified) {
      //proceed
      this.proceed();
    } else {
      this.formProcessing = false;
    }
  }

  async proceed() {
    this.formProcessing = true;
    this.actionErrors = [];

    try {
      if (this.tlaOptionForForm.selectionId) {
        //Edit existing tlaOptionForForm

        let updatedSelectedTlaOption: TlaSelectedOption = await this.tlaService.updateSelectedTlaOption(
          this.courseId,
          this.tlaFormat,
          this.tlaOptionForForm
        );

        if (updatedSelectedTlaOption) {
          //fill the fields from the array
          if (this.tlaOptionsArray[updatedSelectedTlaOption.id]) {
            updatedSelectedTlaOption.description = this.tlaOptionsArray[
              updatedSelectedTlaOption.id
            ].description;
            updatedSelectedTlaOption.isTextRequired = this.tlaOptionsArray[
              updatedSelectedTlaOption.id
            ].isTextRequired;
          }

          //update extent option, if required
          if (this.tlaFormat.isExtentRequired) {
            if (this.tlaFormat.extentFormat == "list") {
              let selectedExtentOption: TlaExtentOption = null;

              for (let extentOption of this.tlaExtentOptionsForForm) {
                if (extentOption.isSelected) {
                  selectedExtentOption = extentOption;
                  // this.tlaOptionForForm.extentOption.otherText = this.tlaExtentOptionDescriptionForForm;

                  break; //break the look, since there's supposed to be only one selection
                }
              }

              //create a new extent Option object
              let extentOption = await this.tlaService.updateSelectedTlaExtentOption(
                this.courseId,
                this.tlaFormat,
                updatedSelectedTlaOption.selectionId,
                selectedExtentOption
              );

              //fill in other information from tlaExtentOptionsArray
              if (this.tlaExtentOptionsArray[extentOption.id]) {
                extentOption.description = this.tlaExtentOptionsArray[
                  extentOption.id
                ].description;
                extentOption.isTextRequired = this.tlaExtentOptionsArray[
                  extentOption.id
                ].isTextRequired;
                // extentOption.otherText = this.tlaExtentOptionsArray[
                //   extentOption.id
                // ].otherText;

                updatedSelectedTlaOption.extentOption = extentOption;
              }
            }
          }

          // replace the updated tla with the current version
          for (let key of Object.keys(this.selectedTlaOptions)) {
            if (
              this.selectedTlaOptions[key].selectionId ==
              updatedSelectedTlaOption.selectionId
            ) {
              this.selectedTlaOptions[key] = updatedSelectedTlaOption;
              break;
            }
          }
        }
      } else {
        //New tlaOptionForForm

        // if (this.tlaFormat.format == "list") {
        //proceed

        let newSelectedTlaOption: TlaSelectedOption;
        //proceed
        newSelectedTlaOption = await this.tlaService.addSelectedTlaOption(
          this.courseId,
          this.tlaFormat,
          this.tlaOptionForForm
        );

        // console.log(newSelectedTlaOption);

        if (newSelectedTlaOption) {
          //fill other fields from the array
          //fill in other information from tlaExtentOptionsArray
          if (this.tlaOptionsArray[newSelectedTlaOption.id]) {
            newSelectedTlaOption.description = this.tlaOptionsArray[
              newSelectedTlaOption.id
            ].description;
            newSelectedTlaOption.isTextRequired = this.tlaOptionsArray[
              newSelectedTlaOption.id
            ].isTextRequired;
          }

          //update extent option, if required
          if (this.tlaFormat.isExtentRequired) {
            if (this.tlaFormat.extentFormat == "list") {
              let selectedExtentOption: TlaExtentOption = null;

              for (let extentOption of this.tlaExtentOptionsForForm) {
                if (extentOption.isSelected) {
                  selectedExtentOption = extentOption;
                  // this.tlaOptionForForm.extentOption.otherText = this.tlaExtentOptionDescriptionForForm;

                  break; //break the look, since there's supposed to be only one selection
                }
              }

              if (selectedExtentOption) {
                //create a new extent Option object
                let extentOption = await this.tlaService.updateSelectedTlaExtentOption(
                  this.courseId,
                  this.tlaFormat,
                  newSelectedTlaOption.selectionId,
                  selectedExtentOption
                );

                //fill in other information from tlaExtentOptionsArray
                if (this.tlaExtentOptionsArray[extentOption.id]) {
                  extentOption.description = this.tlaExtentOptionsArray[
                    extentOption.id
                  ].description;
                  extentOption.isTextRequired = this.tlaExtentOptionsArray[
                    extentOption.id
                  ].isTextRequired;

                  newSelectedTlaOption.extentOption = extentOption;
                }
              }
            }
          }
          this.selectedTlaOptions.push(newSelectedTlaOption);
        }
      }
    } catch (error) {
      console.log(error);
      this.actionErrors.push(error);
      window.scrollTo(0, 0);
    } finally {
      this.formProcessing = false;
      this.shouldShowForm = false;
      this.dimmerService.dimWindow(false);

      this.tlaOptionForForm = null;
      this.tlaExtentOptionDescriptionForForm = null;
      this.tlaExtentOptionsForForm = null;
    }
  }

  /*****************************
   *  Delete TLA functions
   * V.1
   * **************************/

  confirmDeleteTla(tla: TlaSelectedOption) {
    //show dimmer
    this.dimmerService.dimWindow(true);

    this.tlaToDelete = tla;

    this.dialog = new Dialog(
      true,
      "Please confirm",
      'Are you sure you want to delete the teaching and learning activity "' +
      tla.description +
      '"?',
      "No, Don't Delete",
      "Yes, Delete",
      "Processing.."
    );
  }

  /*****************************
   * Proceed with Delete
   * V.1
   * Action Error
   * **************************/
  async proceedDeleteTla() {
    this.dialogUpdating = true;

    try {
      //delete selected assessment method
      await this.tlaService.deleteTlaOptionValue(
        this.courseId,
        this.tlaFormat,
        this.tlaToDelete.selectionId
      );

      //TODO: if extent is required, delete them too

      //
      for (let i = 0; i < this.selectedTlaOptions.length; i++) {
        if (
          this.selectedTlaOptions[i].selectionId == this.tlaToDelete.selectionId
        ) {
          this.selectedTlaOptions.splice(i, 1);
          break;
        }
        // index++;
      }
    } catch (error) {
      console.log(error);
      this.actionErrors.push(error);
    } finally {
      this.dialogUpdating = false;
      this.dimmerService.dimWindow(false);
      this.tlaToDelete = null;
      if (this.dialog) this.dialog.show = false;
    }
  }

  /*****************************
   * Close without deleting TLA
   ***************************/
  cancelDelete() {
    this.clearAll();
  }

  // /**********************
  //  * NextPrev navigation
  //  **********************/

  // nextStepClicked() {
  //   // this.nextStep.emit("tla");

  //   //TODO check if this step is completed.

  //   this.nextStep.emit();
  // }
  // previousStepClicked() {
  //   this.prevStep.emit();
  // }

  closeForm() {
    this.clearAll();
  }

  closeDialog() {
    this.clearAll();
  }

  clearAll() {
    this.loading.isLoading = false;
    this.shouldShowForm = false;
    this.dimmerService.dimWindow(false);
    this.tlaOptionForForm = null;
    this.formProcessing = false;
    this.isTlaSelected = true;
    this.isTlaOptionOtherTextFilled = true;
    this.isTlaExtentOptionSelected = true;
    this.isTlaExtentOptionOtheTextFilled = true;
    this.tlaToDelete = null;
    if (this.dialog) this.dialog.show = false;
    this.dialogUpdating = false;
  }
}
